module.exports = __webpack_public_path__ + "static/assets/54c7b06db115e661414697690313e4d3.svg";